class AnchorNav extends HTMLElement {
  constructor() {
    super();
    this.onIntersect = this.onIntersect.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.list = this.querySelector('.anchor-nav__list');
    this.links = Array.from(this.querySelectorAll('.anchor-nav__link'));
    this.sectionWrapper = this.closest('.shopify-section');

    this.targets = new Map();
    this.links.forEach((link) => {
      const id = decodeURIComponent(link.hash.slice(1));
      const anchor = id ? document.getElementById(id) : null;
      const target = anchor ? anchor.closest('.shopify-section') || anchor : null;
      if (target) this.targets.set(target, link);
    });

    if (this.sectionWrapper && getComputedStyle(this.sectionWrapper).position === 'sticky') {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.sectionWrapper);
    }

    if (this.targets.size === 0) return;

    this.intersectionObserver = new IntersectionObserver(this.onIntersect, {
      rootMargin: '-30% 0px -60% 0px',
    });
    this.targets.forEach((link, target) => this.intersectionObserver.observe(target));
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
    this.resizeObserver?.disconnect();
    this.intersectionObserver = null;
    this.resizeObserver = null;
    document.documentElement.style.removeProperty('--anchor-nav-height');
  }

  onResize() {
    document.documentElement.style.setProperty('--anchor-nav-height', `${this.sectionWrapper.offsetHeight}px`);
  }

  onIntersect(entries) {
    const entry = entries.find((item) => item.isIntersecting);
    if (entry) this.setActive(this.targets.get(entry.target));
  }

  setActive(activeLink) {
    if (!activeLink || activeLink === this.activeLink) return;
    this.activeLink = activeLink;

    this.links.forEach((link) => {
      if (link === activeLink) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    const inset = parseFloat(getComputedStyle(this.list).paddingInlineStart) || 0;
    const linkStart = activeLink.offsetLeft;
    const linkEnd = linkStart + activeLink.offsetWidth;
    if (linkStart < this.scrollLeft || linkEnd > this.scrollLeft + this.clientWidth) {
      this.scrollTo({ left: linkStart - inset, behavior: 'smooth' });
    }
  }
}

if (!customElements.get('anchor-nav')) customElements.define('anchor-nav', AnchorNav);
